"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgBullhornCircle(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M12 0c6.626 0 12 5.374 12 12 0 6.628-5.373 12-12 12-6.628 0-12-5.372-12-12C0 5.373 5.372 0 12 0zm0 1.532C6.218 1.532 1.532 6.219 1.532 12c0 5.782 4.686 10.468 10.468 10.468 5.78 0 10.468-4.686 10.468-10.468C22.468 6.22 17.78 1.532 12 1.532zm4.561 5.563l.007.105v1.986a2.387 2.387 0 010 4.755v1.986a.75.75 0 01-1.027.698l-.095-.047-3.646-2.083H6.545c-.67 0-1.222-.51-1.288-1.163L5.25 13.2V9.927c0-.67.51-1.222 1.163-1.288l.132-.007L11.8 8.63l3.646-2.082a.75.75 0 011.115.546zM12.088 13h-.007l.058.008a.694.694 0 01.141.042.765.765 0 01.103.05l2.685 1.535V8.492l-2.696 1.541a.747.747 0 01-.42.097l-.025.002-1.996-.001v2.864H12l.033.001.028.002h.008L12 12.995l.081.005-.009-.002.016.002zm-3.657-2.87l-1.681.001v2.864h1.681V10.13zm8.138.571v1.725a.887.887 0 000-1.725z",
    fill: "inherit",
    fillRule: "nonzero"
  }));
}

var _default = SvgBullhornCircle;
exports.default = _default;